import React from 'react';
import styles from './Radio.module.css';

const Radio = ({
  label,
  description,
  error,
  disabled = false,
  className,
  ...props
}) => {
  const radioClasses = [
    styles.radio,
    error && styles.error,
    disabled && styles.disabled,
    className
  ].filter(Boolean).join(' ');

  const containerClasses = [
    styles.container,
    error && styles.errorContainer
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      <label className={styles.label}>
        <input
          type="radio"
          className={radioClasses}
          disabled={disabled}
          {...props}
        />
        <span className={styles.radioControl}></span>
        <span className={styles.labelText}>{label}</span>
      </label>
      {description && !error && (
        <p className={styles.description}>{description}</p>
      )}
      {error && (
        <p className={styles.errorMessage}>{error}</p>
      )}
    </div>
  );
};

const RadioGroup = ({
  label,
  options = [],
  description,
  error,
  disabled = false,
  value,
  onChange,
  name,
}) => {
  return (
    <div className={styles.groupContainer}>
      {label && <div className={styles.groupLabel}>{label}</div>}
      <div className={styles.radioGroup}>
        {options.map((option) => (
          <Radio
            key={option.value}
            name={name}
            label={option.label}
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
            disabled={disabled || option.disabled}
          />
        ))}
      </div>
      {description && !error && (
        <p className={styles.description}>{description}</p>
      )}
      {error && (
        <p className={styles.errorMessage}>{error}</p>
      )}
    </div>
  );
};

export { Radio, RadioGroup }; 